module.exports = __webpack_public_path__ + "static/media/15C.5b6f0c52.png";